class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.onResetClick = this.onResetClick.bind(this); // Add this line

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    // Add event listener for reset button
    const resetButton = this.querySelector('[data-type="reset"]');
    if (resetButton) {
      resetButton.addEventListener('click', this.onResetClick);
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  // Add new reset method
  onResetClick(event) {
    event.preventDefault();

    // Get the form element
    const form = this.querySelector('form');

    // Reset all inputs
    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    const radios = form.querySelectorAll('input[type="radio"]');
    const ranges = form.querySelectorAll('input[type="range"]');
    const textInputs = form.querySelectorAll('input[type="text"], input[type="number"]');

    // Reset checkboxes
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });

    // Reset radio buttons
    radios.forEach(radio => {
      radio.checked = false;
    });

    // Reset range inputs and their text counterparts
    ranges.forEach(range => {
      range.value = range.min;
      // Update styling if needed
      if (range.parentElement && range.parentElement.style) {
        range.parentElement.style.setProperty('--range-min', '0%');
        range.parentElement.style.setProperty('--range-max', '100%');
      }
    });

    // Reset text inputs
    textInputs.forEach(input => {
      input.value = '';
    });

    // Render page with empty search parameters
    FacetFiltersForm.renderPage('', event);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }


  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
       // FacetFiltersForm.renderProductCount(html);
       document.dispatchEvent(new Event('filter:update'));
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderProductCount(html);
    document.dispatchEvent(new Event('filter:update'));
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    FacetFiltersForm.open_filter();
    FacetFiltersForm.close_filter();
    FacetFiltersForm.iniate_slider();
    FacetFiltersForm.scrollView();
    FacetFiltersForm.sortingMapMobile();
    FacetFiltersForm.OpenFilterSlider();
    let mobile_media = window.matchMedia("(min-width: 800px)")
    if(mobile_media.matches && typeof initOnHover !== "undefined"){
      initOnHover();
    }
  }

  static sortingMapMobile(){
    let sortElemMob = document.querySelector('.sorting_mobile select');
    if(sortElemMob)
    {
      sortElemMob.addEventListener('change', function(){
        let sortElemDesk = document.querySelector('.sorting_desktop select');
        if(sortElemDesk)
        {
          let index = this.selectedIndex - 1;
          sortElemDesk.options[index].selected = true;
          document.getElementById('FacetFiltersForm').submit();
        }
      })
    }
  }

  static iniate_slider(){
    let slider_items = document.querySelectorAll('.category_slider-item');
    slider_items.forEach(function(item){
        item.addEventListener('click',function(){
            slider_items.forEach(function(slider){
                slider.classList.remove('category-selected');
            })
            item.classList.add('category-selected');
            let cell_index = item.getAttribute('data-index');

            let filter_categoryElem = document.querySelector('.filter-Category');
            if(filter_categoryElem){
                let filter_category_items = filter_categoryElem.querySelectorAll('.facets__item');
                filter_category_items[cell_index].querySelector('label').click();
            }
        })
    })
  }

  static scrollView(){
    let itemParent = document.querySelector('.category_slider');
    if(itemParent){
      itemParent.classList.add('fade-out');
      itemParent.classList.remove('fade');
    }
    let item = document.querySelector('.category_slider-item.category-selected');
    if(item)
    item.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
    setTimeout(() => {
      if(itemParent){
        itemParent.classList.add('fade');
        itemParent.classList.remove('fade-out');
      }
    }, 300);
 }

  static close_filter(){
    let filter_close = document.querySelector('.close_filter');
    filter_close.addEventListener('click', function(){
      document.querySelector('.facets-container').classList.remove('filter-open');
      window.FacetFiletOpened = false;
      document.body.classList.remove('overflow-hidden');
    })
    let drawer_close = document.querySelector('.btns__container [data-type="close"]')
    drawer_close.addEventListener('click', function(e){
      e.preventDefault();
      document.querySelector('.facets-container').classList.remove('filter-open');
      window.FacetFiletOpened = false;
      document.body.classList.remove('overflow-hidden');
    })
  }

  static open_filter(){
    let filter_link = document.querySelector('.filter_link');
    filter_link.addEventListener('click', function(){
      let sliderElem =  document.querySelector('.facets-container');
      sliderElem.classList.add('filter-open');
      window.FacetFiletOpened = true;
      document.body.classList.add('overflow-hidden');
    })
  }

  static OpenFilterSlider(){
    let filter_link = document.querySelector('.facets-container');
    if(filter_link && window.FacetFiletOpened)
     filter_link.classList.add('filter-open');
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);

    // Check for active filters and show/hide reset button
    FacetFiltersForm.toggleResetButton();
  }

  // Add this new method to check for active filters and toggle reset button
  static toggleResetButton() {
    // Get all active filters
    const activeFilters = document.querySelectorAll('.active-facets-desktop .active-facets__button:not(.active-facets__button-remove)');
    const resetButton = document.querySelector('[data-type="reset"]');

    if (resetButton) {
      // Show button only if there's at least one active filter
      if (activeFilters.length > 0) {
        resetButton.classList.remove('hidden');
      } else {
        resetButton.classList.add('hidden');
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

   // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }


  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }



  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    let searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);

    // Check if we need to show/hide reset button after submission
    FacetFiltersForm.toggleResetButton();
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

var PriceRange = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.rangeLowerBound = this.querySelector(
      'input[type="range"]:first-child'
    );
    this.rangeHigherBound = this.querySelector(
      'input[type="range"]:last-child'
    );
    this.textInputLowerBound = this.querySelector(
      'input[name="filter.v.price.gte"]'
    );
    this.textInputHigherBound = this.querySelector(
      'input[name="filter.v.price.lte"]'
    );
    this.textInputLowerBound.addEventListener(
      'focus',
      () => this.textInputLowerBound.select(),
      { signal: this._abortController.signal }
    );
    this.textInputHigherBound.addEventListener(
      'focus',
      () => this.textInputHigherBound.select(),
      { signal: this._abortController.signal }
    );
    this.textInputLowerBound.addEventListener(
      'change',
      (event) => {
        event.preventDefault();
        event.target.value = Math.max(
          Math.min(
            parseInt(event.target.value),
            parseInt(this.textInputHigherBound.value || event.target.max) - 1
          ),
          event.target.min
        );
        this.rangeLowerBound.value = event.target.value;
        this.rangeLowerBound.parentElement.style.setProperty(
          '--range-min',
          `${
            (parseInt(this.rangeLowerBound.value) /
              parseInt(this.rangeLowerBound.max)) *
            100
          }%`
        );
      },
      { signal: this._abortController.signal }
    );
    this.textInputHigherBound.addEventListener(
      'change',
      (event) => {
        event.preventDefault();
        event.target.value = Math.min(
          Math.max(
            parseInt(event.target.value),
            parseInt(this.textInputLowerBound.value || event.target.min) + 1
          ),
          event.target.max
        );
        this.rangeHigherBound.value = event.target.value;
        this.rangeHigherBound.parentElement.style.setProperty(
          '--range-max',
          `${
            (parseInt(this.rangeHigherBound.value) /
              parseInt(this.rangeHigherBound.max)) *
            100
          }%`
        );
      },
      { signal: this._abortController.signal }
    );
    this.rangeLowerBound.addEventListener(
      'change',
      (event) => {
        event.stopPropagation();
        this.textInputLowerBound.value = event.target.value;
        this.textInputLowerBound.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      },
      { signal: this._abortController.signal }
    );
    this.rangeHigherBound.addEventListener(
      'change',
      (event) => {
        event.stopPropagation();
        this.textInputHigherBound.value = event.target.value;
        this.textInputHigherBound.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      },
      { signal: this._abortController.signal }
    );
    this.rangeLowerBound.addEventListener(
      'input',
      (event) => {
        event.target.value = Math.min(
          parseInt(event.target.value),
          parseInt(this.textInputHigherBound.value || event.target.max) - 1
        );
        event.target.parentElement.style.setProperty(
          '--range-min',
          `${
            (parseInt(event.target.value) / parseInt(event.target.max)) * 100
          }%`
        );
        this.textInputLowerBound.value = event.target.value;
      },
      { signal: this._abortController.signal }
    );
    this.rangeHigherBound.addEventListener(
      'input',
      (event) => {
        event.target.value = Math.max(
          parseInt(event.target.value),
          parseInt(this.textInputLowerBound.value || event.target.min) + 1
        );
        event.target.parentElement.style.setProperty(
          '--range-max',
          `${
            (parseInt(event.target.value) / parseInt(event.target.max)) * 100
          }%`
        );
        this.textInputHigherBound.value = event.target.value;
      },
      { signal: this._abortController.signal }
    );
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
};
if (!window.customElements.get('price-range')) {
  window.customElements.define('price-range', PriceRange);
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
      window.infinite_scroll_firstTime = true;
    });
  }
}

customElements.define('facet-remove', FacetRemove);

